module.exports = __webpack_public_path__ + "static/Rosso2-62670a9bcd24992fd7ee240287536bfd.jpg";